'use client'
import { createContext } from 'react';
import { SingleTypes } from './types';




export const ContentContext = createContext<Record<string, SingleTypes> | null>(null);

export function ContentProvider({
  children,
  content,
}: {
  children: React.ReactNode;
  content: Record<string, SingleTypes>;
}) {

  if (!content) throw new Error('content not found')
  return (
    <ContentContext.Provider value={content}>
      {children}
    </ContentContext.Provider>
  );
}

//HOW TO USE
// <ContentProvider content={{ 'traveler': travelerHomePage, 'header': header }}>
// <TravelerHomeClient locale={props.locale} />
// </ContentProvider>

